import { render } from "./modalRelationProducts.vue?vue&type=template&id=90b90ff2&scoped=true&ts=true"
import script from "./modalRelationProducts.vue?vue&type=script&lang=ts"
export * from "./modalRelationProducts.vue?vue&type=script&lang=ts"

import "./modalRelationProducts.vue?vue&type=style&index=0&id=90b90ff2&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90b90ff2"]])

export default __exports__